import { Stack, styled, useTheme } from '@mui/material'
import { Typography, TaskStatus } from 'ComponentLibrary'
import { Check, Circle } from 'react-feather'
import { TypographyVariantTypes } from 'ComponentLibrary/src/atoms/typography/Typography'
import Colors from 'ComponentLibrary/src/styles/colors'

const statusTextMap = {
    open: 'Offen',
    done: 'Abgeschlossen',
}

const taskStatusColorMap = {
    open: Colors.taskStatus.open,
    done: Colors.taskStatus.done,
}

const statusIconMap = {
    open: Circle,
    done: Check,
}

type TaskStatusLabelProps = {
    status: TaskStatus
    size?: number | `${number}px`
    typographyVariant?: TypographyVariantTypes
    label?: string
}

export const TaskStatusLabel = ({ status, typographyVariant = 'captionSmall', size = '20px', label }: TaskStatusLabelProps) => {
    const theme = useTheme()

    const text = label ?? statusTextMap[status]
    const color = taskStatusColorMap[status]
    const Icon = statusIconMap[status]

    return (
        <Stack direction="row" gap={theme.spacing(2)} alignItems="center">
            <SquareIconWrapper $color={color} $size={size} role="status">
                <Icon color={theme.palette.white} height="100%" width="100%" role="status-icon" />
            </SquareIconWrapper>
            <Typography variant={typographyVariant} color={color}>
                {text}
            </Typography>
        </Stack>
    )
}

const SquareIconWrapper = styled('div', {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})<{ $color: string; $size: number | string }>(({ $color, $size }) => ({
    height: $size,
    width: $size,
    flexShrink: 0,
    backgroundColor: $color,
    boxSizing: 'border-box',
    borderRadius: '4px',
    padding: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}))

export function isTaskStatus(value: string): value is TaskStatus {
    return Object.keys(statusTextMap).includes(value)
}
